'use es6';

const BASE64_URL_SAFE_MAP = [['+', '-'], ['/', '_']];
const convertBase64ToUrlSafeBase64 = b64 => {
  return BASE64_URL_SAFE_MAP.reduce((t, v) => t.replace(new RegExp(`\\${v[0]}`, 'g'), v[1]), b64);
};
export default convertBase64ToUrlSafeBase64;